import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import * as firebase from 'firebase';

import { Employee } from '../../model/employee';
import { AuthenticationService } from '../../services/authentication.service';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';
import { FormControl, Validators } from '@angular/forms';

declare var Materialize: any;

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css'],
  providers: [DBService, AuthenticationService]
})
export class EditUserComponent implements OnInit {

  isNoUser: boolean;

  employee: Employee;
  confirmPassword: string;

  isConfirmPasswordWrong: boolean;

  successMessage: string;
  errorMessage: string;

  initLoading: boolean;
  loading: boolean;

  uid: string;

  companies: Company[];

  selectedValue: string;

  isUploadingFile: boolean;
  isCuttingFile: boolean;

  userCompanyUID: string;
  isCompanyAdmin: boolean;

  isCustomer: boolean;

  constructor(private router: Router, private dbService: DBService, private route: ActivatedRoute, private authService: AuthenticationService) {
    this.initLoading = true;
    this.employee = new Employee();

    if (!this.authService.isAdmin()) {
      this.userCompanyUID = this.authService.getUserCompany();
      this.isCompanyAdmin = this.authService.isCustomerAdmin();
    }

    this.route.params
      .subscribe(params => this.initData(params['id']));
  }

  private initData(uid: string) {
    this.uid = uid;
    this.dbService.getObject<Employee>(`employees/${this.uid}`)
      .then(employee => {
        this.employee = employee;
        this.companyChanged();
        this.isNoUser = !this.employee.isUser;

        this.loadCompanies();
      });
  }

  private loadCompanies() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        if (this.userCompanyUID) {
          this.companies = companies.filter(c => c.uid === this.userCompanyUID);
        } else {
          this.companies = companies;
        }
        this.initLoading = false;

        this.updateTextFields();
      });
  }

  private save() {
    this.loading = true;
    const updatingObj = {
      name: this.employee.name,
      job: this.employee.job,
      phone: this.employee.phone,
      companyUID: this.employee.companyUID,
      isUser: this.employee.isUser,
    };

    if (this.employee.photoURL) {
      updatingObj['photoURL'] = this.employee.photoURL;
    }

    if (this.employee.isUser && this.isNoUser) {
      this.employee.password = `Sx'lV$055472\2aU1&J,0c.Mr9K84D`;
      this.authService.createUser(this.employee)
        .then(() => {
          this.authService.sendRecoveryPasswordEmail(this.employee.email);
          this.updateUser(updatingObj);
        });
    } else {
      this.updateUser(updatingObj);
    }
  }

  private updateUser(updatingObj) {
    this.dbService.update(`employees/${this.uid}`, updatingObj)
      .then(() => this.saveSuccess())
      .catch(error => console.log(error));
  }

  private resetPassword() {
    this.employee.password = `Sx'lV$055472\2aU1&J,0c.Mr9K84D`;
    this.authService.sendRecoveryPasswordEmail(this.employee.email);
    this.loading = false;
    const updatingObj = {
      password: this.employee.password,
    };
    Materialize.toast('Nova senha enviada por e-mail com sucesso', 2000);
    this.router.navigate(['/usuarios']);
    this.updateUser(updatingObj);
  }

  private saveSuccess() {
    this.loading = false;

    Materialize.toast('Usuário atualizado com sucesso', 2000);

    this.router.navigate(['/usuarios']);
  }

  private updateTextFields() {
    setTimeout(() => Materialize.updateTextFields(), 100);
  }

  ngOnInit() {
  }

  cancel() {
    this.router.navigate(['/usuarios']);
  }

  public fileChangeEvent($event: any) {
    if ($event.target.files && $event.target.files[0]) {
      this.uploadImage();
    }
  }

  uploadImage() {
    this.isUploadingFile = true;
    const storage = firebase.storage().ref();
    const path = '/users/';
    const files = [(<HTMLInputElement>document.getElementById('custom-input')).files[0]];

    for (const image of files) {
      storage.child(path + image.name).put(image)
        .then((result) => {
          this.employee.photoURL = result.downloadURL;
          this.employee.photoURL = result.downloadURL;
          this.isUploadingFile = false;
        });
    }
  }

  isAdminChanged() {
    if (this.employee.isCompanyAdmin) {
      this.employee.isUser = true;
    }
  }

  companyChanged() {
    this.isCustomer = this.employee.companyUID && this.employee.companyUID !== 'I-Ganhei';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/edit-user/edit-user.component.ts